import React from 'react';
import { useTheme } from 'styled-components';

export const SortArrowsSvg = (props) => {

  const { sortOrder, width, height, color, filled } = props;
  const theme = useTheme();


  if (filled) {
    return (
      <svg className="cursor-pointer" width={width ?? "14"} height={height ?? "20"} viewBox="0 0 4 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 3.625H4L2 0.625L0 3.625Z" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <path d="M4 6.375L0 6.375L2 9.375L4 6.375Z" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
      </svg>
    )
  }


  return (
    <svg className="cursor-pointer" width={width ?? "14"} height={height ?? "20"} viewBox="0 0 4 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      {sortOrder !== 'desc' &&
        <path d="M0 3.625H4L2 0.625L0 3.625Z" fill={sortOrder === 'asc' ? (color ?? theme?.colour?.primary ?? "#1DBD6B") : "#9EACB0"} />
      }
      {sortOrder !== 'asc' &&
        <path d="M4 6.375L0 6.375L2 9.375L4 6.375Z" fill={sortOrder === 'desc' ? (color ?? theme?.colour?.primary ?? "#1DBD6B") : "#9EACB0"} />
      }
    </svg>
  )
}